import { DS_DIRECTION, type DSDirection } from "@/src/design_system/shared/types/direction";

export const DS_RESIZE_HANDLE_CLASSES = {
  Root: "ds-resize-handle",
  Thumb: "ds-resize-handle__thumb",
  DirectionHorizontal: "ds-resize-handle--horizontal",
  DirectionVertical: "ds-resize-handle--vertical",
  Active: "ds-resize-handle--active",
  Disabled: "is-disabled",
} as const;

export const DS_RESIZE_HANDLE_DIRECTION_TO_CLASS_MAP: Record<DSDirection, string> = {
  [DS_DIRECTION.Horizontally]: DS_RESIZE_HANDLE_CLASSES.DirectionHorizontal,
  [DS_DIRECTION.Vertically]: DS_RESIZE_HANDLE_CLASSES.DirectionVertical,
};
